import { render, staticRenderFns } from "./PaymentPeriodCreateModal.vue?vue&type=template&id=84000f94&"
import script from "./PaymentPeriodCreateModal.vue?vue&type=script&lang=js&"
export * from "./PaymentPeriodCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports